import { Host, h } from "@stencil/core";
let id = 0;
export class CoreInputText {
    constructor() {
        this.inputId = `input-text-${++id}`;
        this.handleOnChange = () => {
            this.value = this.element.querySelector('input').value;
            this.coreInputTextValueChange.emit(this.value);
        };
        this.handleOnInput = () => {
            this.value = this.element.querySelector('input').value;
            this.coreInputTextTyping.emit(this.value);
        };
        this.handleFocus = (event) => {
            event.stopImmediatePropagation();
            if (event.type === 'mousedown') {
                this.inFocus = false;
            }
            else {
                this.inFocus = true;
            }
        };
        this.getRequirementString = () => {
            if (this.requirement === 'mandatory') {
                return '·\u00a0obligatoire';
            }
            else if (this.requirement === 'optional') {
                return '·\u00a0facultatif';
            }
        };
        this.renderRequirement = () => {
            return this.requirement !== 'none' ? h("span", { class: "field-requirement typography-body-small-italic" }, this.getRequirementString()) : h("slot", { name: "custom-requirement" });
        };
        this.renderLabel = () => {
            return (h("label", { class: "label typography-body-small-bold", htmlFor: `${this.inputId}`, onClick: e => {
                    this.handleFocus(e);
                } }, this.label, this.renderRequirement()));
        };
        this.renderDescription = () => {
            return this.description && h("span", { class: "description typography-body-small-regular" }, this.description);
        };
        this.renderHeader = (isRenderingDescription) => {
            return (h("div", { class: "input-text-header" }, this.renderLabel(), isRenderingDescription && this.renderDescription()));
        };
        this.renderErrorMessage = () => {
            return (h("span", { id: `${this.inputId}-error-message`, class: "error-message typography-body-small-italic" }, this.errorMessage));
        };
        this.label = undefined;
        this.value = undefined;
        this.description = undefined;
        this.placeholder = undefined;
        this.requirement = 'mandatory';
        this.format = 'inside';
        this.disabled = false;
        this.errorMessage = null;
        this.inError = false;
        this.inFocus = false;
    }
    setErrorState(newValue) {
        if (this.errorMessage) {
            this.inError = true;
        }
        else {
            this.inError = false;
        }
        if (newValue) {
            this.errorMessage = newValue;
        }
    }
    connectedCallback() {
        this.setErrorState(this.errorMessage);
    }
    render() {
        return (h(Host, { key: '5996a98a7955751444a74ab0d70d15018adc3ff6' }, h("div", { key: '6cf02c7ec9da89321ea23ebb89afeb2f8af6666a', class: `core-input-text input-text-format--${this.format} ${this.inError ? 'input-text-in-error' : ''} ${this.disabled ? 'input-text-disabled' : ''} ${this.inFocus ? 'input-text-focus' : ''}` }, this.format !== 'inside' && this.format !== 'hidden' && this.renderHeader(this.description !== undefined), h("div", { key: '108048a366db7c74d46ce38f5d0a1461bdb2deae', class: "input-text-wrapper" }, h("div", { key: '34c5751b3b893ed32bd64188e00928757b551645', class: "input-text-field typography-body-medium-regular", "aria-disabled": this.disabled }, h("slot", { key: 'aff509a7129423169ebcdd60e48f88cfc0c6b238', name: "before" }), h("div", { key: '9d1219ac0dc768c4789e769dfa4c0355af8511bc', class: "field-content" }, this.format === 'inside' && this.renderHeader(false), h("input", { key: '7645a917059deb1980886593d40da57bb90ba769', id: this.inputId, class: "typography-body-medium-regular", "aria-invalid": this.inError, "aria-label": this.format === 'hidden' && this.label, "aria-describedby": this.inError && `${this.inputId}-error-message`, value: this.value, onChange: () => {
                this.handleOnChange();
            }, onInput: () => {
                this.handleOnInput();
            }, onFocus: e => {
                this.handleFocus(e);
            }, onMouseDown: e => {
                this.handleFocus(e);
            }, onBlur: () => {
                this.inFocus = false;
            }, placeholder: this.placeholder })), h("slot", { key: 'a63ee3a04ba8f55865b7aa162ed80b7bebb445fa', name: "after" }), (this.inError || this.disabled) && (h("i", { class: "field-indicator", "aria-hidden": "true" }, this.inError && (h("span", { class: "icon-box" }, h("svg", { style: { width: 'var(--number-size-icon-large)', height: 'var(--number-size-icon-large)' }, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("circle", { cx: "12", cy: "12", r: "11", fill: "#E71616" }), h("path", { d: "M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V5Z", fill: "white" }), h("path", { d: "M12 19.5C12.8284 19.5 13.5 18.8284 13.5 18C13.5 17.1716 12.8284 16.5 12 16.5C11.1716 16.5 10.5 17.1716 10.5 18C10.5 18.8284 11.1716 19.5 12 19.5Z", fill: "white" })))), this.disabled && (h("span", { class: "icon-box" }, h("core-icon", { name: "lock-solid", size: "number-size-icon-large" })))))), this.inError && this.renderErrorMessage()))));
    }
    static get is() { return "core-input-text"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-input-text.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-input-text.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label that accompany the input field. It is required for **accessibility** concerns."
                },
                "attribute": "label",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The value added inside the input. It can be used to add default value."
                },
                "attribute": "value",
                "reflect": false
            },
            "description": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description is available on `outside` and `aside` format and will append below the label."
                },
                "attribute": "description",
                "reflect": false
            },
            "placeholder": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Placeholder inside the select."
                },
                "attribute": "placeholder",
                "reflect": false
            },
            "requirement": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "'mandatory' | 'optional' | 'none'",
                    "resolved": "\"mandatory\" | \"none\" | \"optional\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Mention displayed to indicate if the field is mandatory or optional. If none is selected `custom-requirement` slot is available."
                },
                "attribute": "requirement",
                "reflect": false,
                "defaultValue": "'mandatory'"
            },
            "format": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "'inside' | 'outside' | 'aside' | 'hidden'",
                    "resolved": "\"aside\" | \"hidden\" | \"inside\" | \"outside\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Position the label in different place."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "'inside'"
            },
            "disabled": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A boolean indicating the disable state of the input field. The `aria-disabled` attribute relies on this property."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMessage": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Display an error message under the field and set the field in error state."
                },
                "attribute": "error-message",
                "reflect": false,
                "defaultValue": "null"
            }
        };
    }
    static get states() {
        return {
            "inError": {},
            "inFocus": {}
        };
    }
    static get events() {
        return [{
                "method": "coreInputTextValueChange",
                "name": "coreInputTextValueChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the value has changed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "coreInputTextTyping",
                "name": "coreInputTextTyping",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when typing inside the input."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "errorMessage",
                "methodName": "setErrorState"
            }];
    }
}
//# sourceMappingURL=core-input-text.js.map
